export default __webpack_public_path__ + "static/media/gold-coin.5889daf9.svg";